import { getCardIcon } from './helper';
import styles from './styles.module.scss';
import { UserPaymentDetailsCardProps } from '../props';
import { useTranslation } from '../../../../../../../hooks';
import { UserPaymentDetailsStatus } from '../../../../../../../enums';
import { SettingsService } from '@starsoft/common/services/SettingsService';

export default function UserPaymentDetailsCardStatus({
  userPaymentDetails,
}: Pick<UserPaymentDetailsCardProps, 'userPaymentDetails'>) {
  const { t } = useTranslation('common');

  return (
    <div className={styles.row}>
      <i
        className={`${styles.row__icon} ${getCardIcon(userPaymentDetails?.status)}`}
      />
      <p className={styles.row__description}>
        {t(
          `user_payment_details_${userPaymentDetails?.status === UserPaymentDetailsStatus.Created ? `${userPaymentDetails?.type?.id}_` : ''}${userPaymentDetails?.status}_label`,
          {
            app_provider: SettingsService.env.PROVIDER,
          },
        )}
      </p>
    </div>
  );
}
